<template>
  <v-card max-width="350">
    <v-card-subtitle>{{ $vuetify.lang.t('$vuetify.mapSettings.title') }}</v-card-subtitle>
    <v-divider></v-divider>
    <v-card-text>
      <v-switch v-model="hideAllEventsExceptAccepted"
                :label="$vuetify.lang.t('$vuetify.mapSettings.hideAllEventsExceptAccepted')"></v-switch>
      <v-switch v-model="hideReviewedEvents"
                :label="$vuetify.lang.t('$vuetify.mapSettings.hideReviewedEvents')"></v-switch>
      <v-switch v-model="hideSmallTrips" :label="$vuetify.lang.t('$vuetify.mapSettings.hideSmallTrips')"></v-switch>
      <v-switch v-model="hideViewedTrips" :label="$vuetify.lang.t('$vuetify.mapSettings.hideViewedTrips')"></v-switch>
      <v-switch v-model="clusterEvents" :label="$vuetify.lang.t('$vuetify.mapSettings.clusterEvents')"></v-switch>
      <v-text-field v-model="clusterEventTimePeriod"
                    class="pl-3"
                    :label="$vuetify.lang.t('$vuetify.mapSettings.clusterEventTimePeriod')"
                    :disabled="!clusterEvents" type="number">
      </v-text-field>
      <v-switch v-model="autoScrollManipulatedEvents"
                :label="$vuetify.lang.t('$vuetify.mapSettings.autoScrollManipulatedEvents')"></v-switch>
      <v-row no-gutters>
        <span class="subtitle-2">{{ $vuetify.lang.t('$vuetify.timezoneSettings.title') }}</span>
        <v-col cols="12">
          <v-switch v-model="isActive"
                    :label="$vuetify.lang.t('$vuetify.timezoneSettings.isActive')"></v-switch>
        </v-col>
        <v-col cols="12">
          <v-autocomplete v-model="userTimezone" :items="timezones"
                          :disabled="!isActive" :label="$vuetify.lang.t('$vuetify.timezoneSettings.userTimezone')">
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import { SETTINGS_MODULE } from '../../../store/modules'
import { labeledTimezones, timezones } from '@/utils/timezone'

const { mapFields } = createHelpers({
  getterType: `${SETTINGS_MODULE}/getField`,
  mutationType: `${SETTINGS_MODULE}/updateField`
})

export default {
  name: 'generalSettingsCard',
  computed: {
    ...mapFields(['mapSettings.hideAllEventsExceptAccepted', 'mapSettings.hideReviewedEvents', 'mapSettings.hideSmallTrips', 'mapSettings.hideViewedTrips',
      'mapSettings.clusterEvents', 'mapSettings.clusterEventTimePeriod', 'mapSettings.autoScrollManipulatedEvents',
      'timezoneSettings.isActive', 'timezoneSettings.userTimezone'])
  },
  data: () => ({
    timezones: labeledTimezones()
  })
}
</script>

<style scoped>

</style>
